import { serviceProvider, statusChangeRequest } from "./serviceProvider";
/**
 * all api services of zone overview
 */
const zoneServices = {
  getZoneList,
  getTimeZoneList,
  CreateOrUpdateZone,
  DeactivateZone,
  ReactivateZone,
};
/**
 *
 * @param {*payload of Pagination,ZoneName to fetch zone list} reqPayload
 * @param {* Bearer token for authentication} headerData
 * @returns
 */
async function getZoneList(reqPayload, headerData) {
  return await serviceProvider(
    "POST",
    "Zone/GetZoneList",
    reqPayload,
    headerData ? headerData : {}
  );
}

/**
 *
 * @param {*payload of timeZoneRequest to fetch time zone list} reqPayload
 * @param {* Bearer token for authentication} headerData
 * @returns
 */
async function getTimeZoneList(reqPayload, headerData) {
  return await serviceProvider(
    "POST",
    "GenericDropdown/FillDropDownValues",
    reqPayload,
    headerData ? headerData : {}
  );
}

/**
 *
 * @param {*payload of all value of zone to create and edit zone i.e. zoneName, zoneNumber, Sch Path, Ver Path} reqPayload
 * @param {* Bearer token for authentication} headerData
 * @returns
 */
async function CreateOrUpdateZone(reqPayload, headerData) {
  return await serviceProvider(
    "POST",
    "Zone/CreateOrUpdate",
    reqPayload,
    headerData ? headerData : {}
  );
}

/**
 * @description soft-delete a zone
 * @param {*id of zone} zoneId
 * @param {* Bearer token for authentication} headerData
 * @returns
 */
async function DeactivateZone(zoneId, headerData) {
  return await statusChangeRequest("Zone/Deactivate", zoneId, headerData);
}

/**
 * @description restore a deactivated zone
 * @param {*id of zone} zoneId
 * @param {* Bearer token for authentication} headerData
 * @returns
 */
async function ReactivateZone(zoneId, headerData) {
  return await statusChangeRequest("Zone/Reactivate", zoneId, headerData);
}

export default zoneServices;
